import {Component, Input, OnInit} from '@angular/core';

import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-warning',
  templateUrl: './modal-warning.component.html',
  styleUrls: ['./modal-warning.component.scss']
})
export class ModalWarningComponent implements OnInit {

  @Input() title: string;
  @Input() description: string;
  @Input() textDismiss: string;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {

  }
}
